import { Fragment } from 'react';
import { ResponsiveTwoColumns } from '@mews-commander/ui';
import { DateField } from '../DateField';
import { DateIntervalFieldsProps } from './types';
import { useValidateDateInterval } from './useValidateDateInterval';

export const DateIntervalFields = ({
    autocorrect = true,
    maxDate,
    maxDayDifference,
    minDate,
    mode,
    endDateProps,
    startDateProps,
    inline = false,
    size,
    ...other
}: DateIntervalFieldsProps) => {
    const { maxEndDate, minEndDate } = useValidateDateInterval({
        autocorrect,
        endDateProps,
        startDateProps,
        maxDayDifference,
        maxDate,
        minDate,
        mode,
        ...other,
    });

    const WrapperElement = inline ? ResponsiveTwoColumns : Fragment;
    return (
        <WrapperElement>
            <DateField minDate={minDate} maxDate={maxDate} mode={mode} size={size} {...startDateProps} />
            <DateField minDate={minEndDate} maxDate={maxEndDate} mode={mode} size={size} {...endDateProps} />
        </WrapperElement>
    );
};
